/* eslint-disable no-console */
import {toast} from 'react-toastify';
import {Operation} from 'fast-json-patch';
import {IPresentation} from '../incase-domain/presentation';
import {ISlidePreview} from '../incase-domain/proptypes/slidePreview';
import {ISlide, SlideWithoutElements} from '../incase-domain/slide';
import {httpDelete, httpGet, httpPatch, httpPost, httpPut} from './http.service';
import i18n from '../i18n';

export const saveSlideSwap = (presentationId: string, newIndex: number, oldIndex: number): Promise<void> => {
    return httpPut(`editor/slides/swap/${presentationId}`, {newIndex, oldIndex}).catch((error) => {
        console.log(error);
    });
};

export const addSlides = (presentationId: string, slidesToAdd: number, position: number, hidden: boolean): Promise<IPresentation> => {
    return httpGet(`editor/slides/add/${presentationId}/${slidesToAdd}/${position}/${hidden}`).catch((error) => {
        console.log(error);
    });
};

export type CopyPresentationSlideResult = {
    slide: ISlide;
    slidePreview?: ISlidePreview;
};

export type CopyPresentationSlidesResult = {
    presentation: IPresentation;
    copies: CopyPresentationSlideResult[];
};

export const copyPresentationSlides = (presentationId: string, slideIds: string[]): Promise<CopyPresentationSlidesResult | void> => {
    return httpPost<CopyPresentationSlidesResult>(`editor/slides/copySlides/${presentationId}`, {slideIds}).catch(() => {
        toast.error(i18n.t('toasts.slideDuplicateFail'));
    });
};

export const importPresentationSlide = (
    slideIds: string[],
    presentationId: string
): Promise<{slideIndexList: string[]; newSlides: ISlide[]}> => {
    return httpPost(`editor/slides/import/${presentationId}`, {slideIds}).catch((error) => {
        toast.error(i18n.t('toasts.importSlideFail'), error.response.status);
        return error.response.data;
    });
};

export const saveSlide = (slide: ISlide, isRejected?: boolean): Promise<ISlide> => {
    return httpPut(`editor/slides/save`, {slide, isRejected});
};

export const updateSlidesWithoutElements = (presentationId: string, slides: SlideWithoutElements[]): Promise<SlideWithoutElements[]> => {
    return httpPut(`editor/slides/updateSlidesWithoutElements/${presentationId}`, {slides});
};

export const deleteSlides = (presentationId: string, slideIds: string[]): Promise<{removed: boolean; removedIds: string[]} | void> => {
    return httpDelete(`editor/slides/deleteSlides/${presentationId}`, {slideIds}).catch((error) => {
        console.log(error);
    });
};

export const saveSlidePatch = (slideId: string, patch: Operation[]): Promise<void> => {
    return httpPatch(`editor/slides/savePatch`, {slideId, patch});
};
